import script from "./ConfigView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigView.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigView.vue?vue&type=style&index=0&id=d48a0e24&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d48a0e24"]])

export default __exports__